export default [
  {
    path: '/sd',
    component: () => import('@/views/sd/index.vue'),
    meta: {
      title: '供需列表'
    }
  },
  {
    path: '/sd/demand',
    component: () => import('@/views/sd/demand/index.vue'),
    meta: {
      title: '需求列表'
    }
  },
  {
    path: '/list/sd',
    component: () => import('@/views/sd/demand/list.vue'),
    meta: {
      title: '需求列表'
    }
  },
  {
    path: '/sd/supply',
    component: () => import('@/views/sd/supply/index.vue'),
    meta: {
      title: '供应列表'
    }
  },
  {
    path: '/sd/demand/show',
    component: () => import('@/views/sd/demand/show.vue'),
    meta: {
      title: '需求详情',
      isAuth: true
    }
  },
  {
    path: '/sd/supply/show',
    component: () => import('@/views/sd/supply/show.vue'),
    meta: {
      title: '供应详情'
    }
  }
]
